import { createContext, useContext } from '@wordpress/element';

export const PlayerContext = createContext(null);

export function usePlayer() {
    const context = useContext(PlayerContext);

    if (!context) {
        throw new Error('usePlayer must be used inside PlayerProvider');
    }

    return context;
}